import BasePage from '../../components/basePage';
import HeaderHome from '../../components/home/headerHome';
import ContentHome from '../../components/home/contentHome';

const HomePage = () => {

    return (
        <BasePage>
           <HeaderHome/>
           <ContentHome/>
        </BasePage>

    )
}

export default HomePage;